/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Edittitle1Inputs */

const he_account_reviews_edittitle1 = /** @type {(inputs: Account_Reviews_Edittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ערוך ביקורת`)
};

const en_account_reviews_edittitle1 = /** @type {(inputs: Account_Reviews_Edittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Review`)
};

/**
* | output |
* | --- |
* | "Edit Review" |
*
* @param {Account_Reviews_Edittitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const account_reviews_edittitle1 = /** @type {((inputs?: Account_Reviews_Edittitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Edittitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_edittitle1(inputs)
	return en_account_reviews_edittitle1(inputs)
});
export { account_reviews_edittitle1 as "account_reviews_editTitle" }